import { Arrow } from "components/page-components/Icons/small"
import React from "react"
import { updateInternalSearchSessionStorage } from "components/page-components/Internal-Search/utils"

export const ClearFocussedType = ({
  set_focussed,
  setSearchState,
  all_types,
}) => {
  const { last_search_state } = JSON.parse(
    sessionStorage.getItem("internal_search_session_storage")
  )

  const updated_search_state = {
    ...last_search_state,
    refinementList: { ...last_search_state.refinementList, type: all_types },
  }
  const clear_type = () => {
    updateInternalSearchSessionStorage({
      last_search_state: updated_search_state,
      focussed: false,
    })
    set_focussed(false)
    setSearchState(updated_search_state)
  }

  return (
    <div
      className="level-item is-clickable"
      onClick={clear_type}
      onKeyPress={() => {}}
      role="button"
      tabIndex="-1"
      aria-label="clear focus"
      title="Filter zurücksetzen"
    >
      <p className="title is-4 has-text-white">
        <Arrow {...{ direction: "left", color: "#FFFFFF", size: 0.8 }} />
      </p>
    </div>
  )
}
